import { createContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { getDefaultMetricDisplay } from "helpers/metrics"
import { usePreferences } from "hooks/use-preferences"

const PREFERENCE_SUBTYPE = "asset-view-beta"
const PREFERENCE_FIELDS = [
  "selectedMetricDisplay",
]

const DEFAULT_STATE = {
  selectedMetricDisplay: getDefaultMetricDisplay("beta"),
}

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setSelectedMetricDisplay":
        draft.selectedMetricDisplay = action.selectedMetricDisplay
        break
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
    }
  })
}

function setPreferences(preferences) {
  return { type: "setPreferences", preferences }
}

export const BETA_CONTEXT = createContext()

export default function BetaContext({ children }) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)

  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setSelectedMetricDisplay: (selectedMetricDisplay) => dispatch({ type: "setSelectedMetricDisplay", selectedMetricDisplay }),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return <BETA_CONTEXT.Provider value={contextValue}>
    {children}
  </BETA_CONTEXT.Provider>
}
